enum Finances {
  home = '/finances',
  listRecoveryNotice = '/finances/recovery-notice',
  listPayments = '/finances/customers-situation',
  treasury = '/finances/treasury',
}

export default Finances;
